export const IDENTITIES_LIST = {
  TITLE: 'Revisión de Accesos',
  SEARCH_PLACEHOLDER: 'Buscar por cuenta o propietario',
  SOURCE_PLACEHOLDER: 'Seleccionar fuente',
  NAME: 'Nombre',
  ACCOUNT_NAME: 'Nombre de la cuenta',
  OWNER: 'Propietario',
  EMAIL: 'Email',
  MFA: 'MFA',
  SOURCE: 'Fuente',
  LAST_LOGIN: 'Último acceso',
  STATUS: 'Estado',
  ROLE: 'Rol',
  ROLES: 'Roles',
  TWO_FA: '2FA',
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
  REMOVED: 'Eliminado',
  ENABLED: 'Habilitado',
  DISABLED: 'Deshabilitado',
  LOADING: 'Cargando identidades...',
  NO_IDENTITIES: 'No se encontraron identidades',
}
